import * as React from "react";
import { ReactComponent as IconWarning } from "../../assets/icon-warning.svg";

interface Props {
  revision?: string;
  title?: string;
  freeTextSubtitle?: string | boolean;
}

const WarningBannerFormRegistration: React.FC<Props> = ({
  title = "Harap edit data berikut",
  revision,
  freeTextSubtitle = false,
}) => {
  const removeHtmlTag = (tag: string | boolean | undefined): string[] => {
    if (typeof tag === "string") {
      const removeTag = tag.replace(/<[^>]*>/g, "");
      const removeBreaking = removeTag.replace(/(\r\n|\n|\r)/gm, "");
      const splitStringIntoList = removeBreaking.split("\t");
      return splitStringIntoList.filter((data) => data.length > 0);
    }
    return [];
  };

  const revisionList = freeTextSubtitle
    ? revision
    : removeHtmlTag(revision) ?? [];

  return (
    <div className="flex items-center gap-x-[8px] h-auto min-h-[62px] w-full border-y-[#FFBC00] border-y-[1px] bg-[#FFF2DB] py-[8px] px-[16px]">
      <IconWarning />
      <div className="w-full">
        <h1 className="leading-none text-[13px] font-semibold mb-0">{title}</h1>
        {(freeTextSubtitle || revision) &&
          (freeTextSubtitle ? (
            <>
              {revisionList?.map((revision, idx) => (
                <p
                  key={idx}
                  dangerouslySetInnerHTML={{ __html: revision }}
                  className="text-[11px] text-[#6A7481] leading-[13px] mb-0"
                />
              ))}
            </>
          ) : (
            <>
              <ul className="mt-[4px] ml-[20px] list-disc">
                {revisionList?.map((revision, idx) => (
                  <li
                    key={idx}
                    dangerouslySetInnerHTML={{ __html: revision }}
                    className="text-[11px] text-[#6A7481] leading-[13px]"
                  />
                ))}
              </ul>
            </>
          ))}
      </div>
    </div>
  );
};

export default WarningBannerFormRegistration;
